import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { TariffLookups, TariffLookupsParams } from './model';
import { TariffLookupsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export const TariffLookupsRoute = (model : (params : TariffLookupsParams) => TariffLookups, appWrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <TariffLookupsView model={model(inboundParams(request))} />
        </AppWrapperView>
});

function inboundParams(request : Location) : TariffLookupsParams {
    return {
        id: +(request.params['id'] || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/tarifflookups/route.tsx